<template>
  <img :src="`${imageRoot}${context.image}`"
    :alt="context.label"
    :class="context.class" 
    />
</template>

<script>
export default {
  name: "ImageContainer",
  props: {
    context: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>

</style>